const fullApiUrl = process.env.REACT_APP_API_URL;
const apiVersion = process.env.REACT_APP_API_VERSION;
const appKey = process.env.REACT_APP_KEY;
const appVersion = process.env.REACT_APP_APP_VERSION;

const networkSettings = {
  fullApiUrl,
  apiVersion,
  appKey,
  appVersion,
};

export default networkSettings;
